export { default } from './IssuePreviewDetailsTabGeneralSection';
